import Controller from '@ember/controller'
import { tracked } from '@glimmer/tracking'

export default class ManageStudentsNewController extends Controller {
  queryParams = ['schoolId']

  @tracked schoolId = ''
}
